import * as React from "react";

import { Box, Container } from "../../base";

interface CPAppLayoutProps {
  children?: React.ReactNode;
}

const CPAppLayout: React.FC<CPAppLayoutProps> = ({ children }) => {
  return (
    <Box className="cp-app-main">
      <Container className="page-container">{children}</Container>
    </Box>
  );
};

export default CPAppLayout;
